// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "build/js/" + chunkId + "." + {"594":"e37a17b0","959":"0c71fdbb"}[chunkId] + ".js";
};